import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Table, Button, Modal, Badge } from 'react-bootstrap'
import Card from '../../../components/Card'
import { PrivacyService } from '../../../service/privacy-service'
import { successToast, warningToast } from '../../../constants/Toasts-Components'
import ReactLoading from "react-loading"

const statusBadge = (status) => {
  const map = {
    CREATED: 'secondary',
    SENT: 'primary',
    FAILED: 'danger',
    SIGNED: 'warning',
    CONFIRMED: 'success',
  }
  return <Badge bg={map[status] || 'secondary'}>{status}</Badge>
}

const Privacy = () => {
  const { config } = useSelector((state) => state.auth)
  const privacyService = new PrivacyService()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedItem, setSelectedItem] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [confirming, setConfirming] = useState(false)

  const canConfirmPrivacy = config?.is_admin || config?.is_agency_admin || config?.is_agency_boss || config?.is_internal_backoffice_manager || config?.is_institute_backoffice_manager

  async function fetchList() {
    setLoading(true)
    try {
      const data = await privacyService.list()
      setItems(data)
    } catch (error) {
      console.error('Error fetching privacy list:', error)
      warningToast('Errore durante il caricamento della lista privacy')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchList() }, [])

  function handleRowClick(item) {
    setSelectedItem(item)
    setShowModal(true)
  }

  async function handleConfirm() {
    if (!selectedItem) return
    setConfirming(true)
    try {
      const updated = await privacyService.confirm(selectedItem.id)
      successToast('Privacy confermata con successo!')
      setSelectedItem(updated)
      fetchList()
    } catch (error) {
      console.error('Error confirming privacy:', error)
      warningToast(error.response?.data?.error || 'Errore durante la conferma')
    } finally {
      setConfirming(false)
    }
  }

  if (loading) {
    return (
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
          <ReactLoading type="spin" color="#360623" height={50} width={50} />
        </div>
      </Container>
    )
  }

  return (
    <Container fluid>
      <Row>
        <Col lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Privacy</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Contatto</th>
                      <th>Telefono</th>
                      <th>Agente</th>
                      <th>Stato</th>
                      <th>Data</th>
                      <th>Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          Nessuna privacy trovata
                        </td>
                      </tr>
                    )}
                    {items.map((item) => (
                      <tr key={item.id} style={{ cursor: 'pointer' }} onClick={() => handleRowClick(item)}>
                        <td>{item.contact_name}</td>
                        <td>{item.contact_phone}</td>
                        <td>{item.agent_name}</td>
                        <td>{statusBadge(item.status)}</td>
                        <td>{item.created_at ? `${new Date(item.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(item.created_at).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'})}` : '-'}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {item.can_be_confirmed && canConfirmPrivacy && (
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() => {
                                setSelectedItem(item)
                                setShowModal(true)
                              }}
                            >
                              Conferma
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Detail Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="text-white">Dettaglio Privacy</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {selectedItem && (
            <div className="table-responsive shadow-sm rounded">
              <Table bordered hover className="mb-0">
                <tbody>
                  <tr>
                    <th className="bg-light" style={{ width: '40%' }}>Contatto</th>
                    <td className="align-middle text-dark font-weight-bold">{selectedItem.contact_name}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Telefono</th>
                    <td className="align-middle">{selectedItem.contact_phone}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Agente</th>
                    <td className="align-middle">{selectedItem.agent_name}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Stato</th>
                    <td className="align-middle">{statusBadge(selectedItem.status)}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Privacy Check 1</th>
                    <td className="align-middle">
                      <Badge bg={selectedItem.privacy_check1 ? 'success' : 'danger'}>
                        {selectedItem.privacy_check1 ? 'Si' : 'No'}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light">Data Appuntamento</th>
                    <td className="align-middle">{selectedItem.appointment_date ? new Date(selectedItem.appointment_date).toLocaleDateString('en-GB').replace(/\//g, '-') : '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Ora Appuntamento</th>
                    <td className="align-middle">{selectedItem.appointment_time || '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Attiva</th>
                    <td className="align-middle">
                      <Badge bg={selectedItem.is_active ? 'success' : 'warning'} text={selectedItem.is_active ? 'light' : 'dark'}>
                        {selectedItem.is_active ? 'Si' : 'No'}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light">Scaduta</th>
                    <td className="align-middle">
                      <Badge bg={selectedItem.is_expired ? 'danger' : 'success'}>
                        {selectedItem.is_expired ? 'Si' : 'No'}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light">Firmata il</th>
                    <td className="align-middle">{selectedItem.signed_on ? `${new Date(selectedItem.signed_on).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(selectedItem.signed_on).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'})}` : '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Indirizzo IP</th>
                    <td className="align-middle">{selectedItem.ip_address || '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Creata il</th>
                    <td className="align-middle">{selectedItem.created_at ? `${new Date(selectedItem.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(selectedItem.created_at).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'})}` : '-'}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Aggiornata il</th>
                    <td className="align-middle">{selectedItem.updated_at ? `${new Date(selectedItem.updated_at).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(selectedItem.updated_at).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'})}` : '-'}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {selectedItem && selectedItem.can_be_confirmed && canConfirmPrivacy && (
            <Button variant="success" onClick={handleConfirm} disabled={confirming}>
              {confirming ? 'Conferma in corso...' : 'Conferma Privacy'}
            </Button>
          )}
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Privacy
